import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getAccessToken } from '@whitelabel/helpers/api';
import { IError } from '@whitelabel/helpers/types';
import { captureExceptionWithFullyStory } from '@whitelabel/helpers/utils';

const API_HOST = process.env.NEXT_PUBLIC_API_HOST;

// Define a service using a base URL and expected endpoints
export const xcoverAPI = createApi({
  reducerPath: 'xcoverApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_HOST}/`,
    prepareHeaders: async (headers) => {
      try {
        const token = await getAccessToken(true);
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
      } catch (error) {
        captureExceptionWithFullyStory(error as IError);
        return headers;
      }
    },
  }),
  endpoints: () => ({}),
});
